import { Component, OnInit, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
// import { IBrandInfo } from '../../interfaces/brand-info';
import { ISessionDetails } from '../../../interfaces/session-details';
import { IEnrollmentLink } from '../../../interfaces/enrollment/enrollment-link';
import { EnrollmentService } from '../../../services/enrollment/enrollment.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-smart-link-enhanced',
    standalone: true,
    imports: [],
    templateUrl: './smart-link-enhanced.component.html',
    styleUrl: './smart-link-enhanced.component.css'
})
export class SmartLinkEnhancedComponent implements OnInit {

  // @Input() data: any;

  private readonly router = inject(Router);
  private readonly dataExchangeService = inject(DataExchangeService);
  private readonly enrollmentService  = inject(EnrollmentService);
  private readonly logger = inject(NGXLogger);

  successMessage!: string;
  errorMessage!: string;
  isSuccessMessageShown: boolean = false;
  isErrorMessageShown: boolean = false;

  region!: string;

  title!: string;
  isTitleShown: boolean = false;

  subtitle!: string;
  isSubtitleShown: boolean = false;

  enrollmentButtons!: IEnrollmentLink[];
  enrollmentButtonsText!: string;

  constructor() {
  }

  ngOnInit() {
    this.region = this.dataExchangeService.getRegion();
    let session: ISessionDetails = this.dataExchangeService.getSession();
    if (this.region && session) {
      // Retrieve the QR code url
      // this.getQRCode(this.region, session.walPageUuid || '', session.source);
    }
    this.setCustomizations(this.region, session.walPageUuid || '', session.source);
  }

  public setCustomizations(region: string, sessionId: string, source?: string) {
    // let brandInfo: IBrandInfo = this.dataExchangeService.getBrandInfo();

    this.enrollmentService.getEnrollmentButtons(region, sessionId, source)
    .subscribe({
      next: (response) => {
        if (response) {
          this.enrollmentButtons = response;
          if (response.find(item => item.platform === 'pb') && response.find(item => item.platform === 'gw')
            && !response.find(item => item.platform === 'sw')) {
           this.enrollmentButtonsText = 'Apple Wallet or Google Wallet';
         } else if (!response.find(item => item.platform === 'pb') && response.find(item => item.platform === 'gw')
           && response.find(item => item.platform === 'sw')) {
          this.enrollmentButtonsText = 'Google Wallet or Samsung Wallet';
         } else {
           this.enrollmentButtonsText = 'Apple Wallet, Google Wallet or Samsung Wallet';
         }
       }
      },
      error: (error) => {
        // this.logger.error('SmartLinkEnhancedComponent', 'setCustomizations()', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });


    this.title = this.dataExchangeService.getConfigPropertyByName("WAL_PAGES_SMART_LINK_TITLE") || ''; // "Mobile Wallet Enrollment";
    this.isTitleShown = this.title ? true : false;
    this.subtitle = this.dataExchangeService.getConfigPropertyByName("WAL_PAGES_SMART_LINK_SUBTITLE") || '';
//      "Please click the button below to enroll to ";
    this.isSubtitleShown = this.subtitle ? true : false;
    this.isTitleShown = this.title ? true : false;

  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }

}

